<template>
    <div>
        <el-form :model="ruleForm[index]" :rules="rules" :ref="ruleForm[index]" label-width="10vw" class="ruleForm" v-for="(item,index) in formData" :key="index">
            <el-form-item :label="item.name" prop="value">
                <el-input v-model="ruleForm[index].value"></el-input>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    props: ['formData'],
    data() {
        return {
            ruleForm:[],
            rules: {}
        }
    },
    created() {
        this.ruleForm = this.formData
    },
    watch: {
        // ruleForm(newV) {
        // }
    }
}
</script>

